import { supplier_username_login, getUserInfo } from '@/api/index'; // 确保导入所有需要的 API

const state = {
  token: localStorage.getItem('token') || '', 
  id: localStorage.getItem('id') || '', // 从本地存储初始化用户ID
  id: localStorage.getItem('username') || '',
  userInfo: null,
  permissions: [],
  loading: false,
  error: null
};

const getters = {
  isLoggedIn: state => !!state.token,
  currentUser: state => state.userInfo,
  userName: state => state.username, //username
  userId: state => state.id, // 新增getter获取用户ID
  userPermissions: state => state.permissions,
  authLoading: state => state.loading,
  authError: state => state.error
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
    // 保存到本地存储
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  },
  SET_ID(state, id) {
    state.id = id;
    // 保存到本地存储
    if (id) {
      localStorage.setItem('id', id);
    } else {
      localStorage.removeItem('id');
    }
  },
  SET_USERNAME(state, username) {
    state.username = username;
    // 保存到本地存储
    if (username) {
      localStorage.setItem('username', username);
    } else {
      localStorage.removeItem('username');
    }
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_AUTH(state) {
    state.id = '';
    state.token = '';
    state.userInfo = null;
    state.permissions = [];
    state.error = null;
    localStorage.removeItem('token');
    localStorage.removeItem('id'); // 登出时清除ID
  }
};

const actions = {
  async login({ commit }, credentials) {
    console.log(credentials, "credentials");
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      
      // 调用登录API
      const response = await supplier_username_login(credentials);
      console.log(response, 'response');
      
      // 提取数据（根据实际API返回格式调整）
      const { token, userInfo, permissions, id,username } = response.data;
      
      // 保存到store和本地存储
      commit('SET_ID', id);
      commit('SET_TOKEN', token);
      commit('SET_USER_INFO', userInfo);
      commit('SET_USERNAME', username);
      commit('SET_PERMISSIONS', permissions);
      
      
      return userInfo;
    } catch (error) {
      // 提取更具体的错误信息
      const errorMessage = error.response?.data?.message || error.message || '登录失败';
      commit('SET_ERROR', errorMessage);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  async logout({ commit }) {
    try {
      // 清除store
      commit('CLEAR_AUTH');
      
      // 可以在这里调用后端的注销API
      
      return Promise.resolve();
    } catch (error) {
      commit('SET_ERROR', error.message);
      return Promise.reject(error);
    }
  },
  
  async fetchUserInfo({ commit, state }) {
    if (!state.token) return;
    
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      
      // 调用获取用户信息API
      const response = await getUserInfo(); // 确保这个方法已导入
      
      // 更新用户信息和ID
      if (response.data.id) {
        commit('SET_ID', response.data.id);
      }
      commit('SET_USER_INFO', response.data);
      
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || '获取用户信息失败';
      commit('SET_ERROR', errorMessage);
      
      // 如果token无效，清除认证状态
      if (error.response?.status === 401) {
        commit('CLEAR_AUTH');
      }
      
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};